/* import __COLOCATED_TEMPLATE__ from './fin-referenced-personalised-attributes.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import templateOnlyComponent from '@ember/component/template-only';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type FinReferencedPersonalisedAttributes from 'embercom/objects/inbox/renderable/fin-referenced-personalised-attributes';

export interface FinReferencedPersonalisedAttributesSignature {
  Args: {
    part: RenderablePart & { renderableData: FinReferencedPersonalisedAttributes };
  };
}

const FinReferencedPersonalisedAttributesPartComponent =
  templateOnlyComponent<FinReferencedPersonalisedAttributesSignature>();
export default FinReferencedPersonalisedAttributesPartComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::FinReferencedPersonalisedAttributes': typeof FinReferencedPersonalisedAttributesPartComponent;
    'inbox2/conversation-stream/event-parts/fin-referenced-personalised-attributes': typeof FinReferencedPersonalisedAttributesPartComponent;
  }
}
